import './_style.css'
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {NavLink, useParams} from "react-router-dom";
import {IProjGridFilter, IProjGridQuery} from "../../helpers/Interfaces";
import PaginationBar from "../../components/PaginationBar"
import ProjFilterBlock from "./ProjFilterBlock";
import TopNavBar from "../../components/TopNavBar";
import BreadCrumbs from "../../components/BreadCrumbs";
import Footer from "../../components/Footer"


function ProjectBlock(props: any) {

    const {linkTo, prjType, prjItem} = props
    // console.log(prjItem)
    return (
        <NavLink to={linkTo}>
            <div className="prj-block">
                <div>{prjItem.projName}</div>
                <div>{prjType}</div>
                <div>{prjItem.srcTaxName}</div>
                <div>{prjItem.trgTaxName}</div>
                <div>{prjItem.prodsNum}</div>
                <div>{prjItem.locsNum}</div>
                <div className="map-stats">
                    <div style={ prjItem?.srcCatsStats?.coverage > 90 ? {color: "#008000"} : {color: "#111111"} }>{prjItem?.srcCatsStats?.coverage}%</div>
                    <div style={{fontSize: "0.68rem", color: "#737373"}}>({prjItem?.srcCatsStats?.mapped}/{prjItem?.srcCatsStats?.total})</div>
                    <div style={{position: "relative"}}>
                        <div style={{position: "absolute", top: "-18px", fontSize: "0.69rem", color: "#cc0000"}}>
                            {prjItem?.srcCatsStats?.newItems && <span>new</span>}
                        </div>
                    </div>
                </div>

                <div className="map-stats">
                    <div style={ prjItem?.srcCatFeatsStats?.coverage > 90 ? {color: "#008000"} : {color: "#111111"} }>{prjItem?.srcCatFeatsStats?.coverage}%</div>
                    <div style={{fontSize: "0.68rem", color: "#737373"}}>({prjItem?.srcCatFeatsStats?.mapped}/{prjItem?.srcCatFeatsStats?.total})</div>
                    <div style={{position: "relative"}}>
                        <div style={{position: "absolute", top: "-18px", fontSize: "0.69rem", color: "#cc0000"}}>
                            {prjItem?.srcCatFeatsStats?.newItems && <span>new</span>}
                        </div>
                    </div>
                </div>

                <div>{prjItem.lastRun}</div>
            </div>
        </NavLink>
    )
}

export default function MapperHome() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    // console.log(user.username, userPermissions)

    // cleaning 'residual' filtering settings from the local storage
    localStorage.removeItem("filterFields")
    localStorage.removeItem("filterFeats")
    localStorage.removeItem("filterProds")

    const {page_num} = useParams()

    const [filterObj, setFilterObj] = useState<IProjGridFilter>({
        projType: '',
        projName: '',
    })

    const [pageData, setPageData] = useState({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: [],
        currentPage: null
    })

    const [queryObj, setQueryObj] = useState<IProjGridQuery>({
        postsPerPage: 15,
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: filterObj
    })

    useEffect(() => {
        if ('allowedProjUIDs' in userPermissions) {
            getProjects()
        }
    }, [queryObj, userPermissions])

    let getProjects = async () => {
        let response = await fetch(`${serverIP}/getprojects/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access),
            },
            body: JSON.stringify({...queryObj, ...userPermissions})
        })
        let data = await response.json()

        if (response.status === 200) {
            setPageData(prevState => {
                return {
                    ...prevState,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    dataList: data.pagePosts,
                    currentPage: data.currentPage
                }
            })
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const projElems = pageData.dataList.map((item: any, index) => {
        let linkTo = `../prj/${item.projUID}/details`    // stats page
        // let linkTo = `../prj/${item.projUID}/fields/1`
        let prjType: string = (item.srcTaxID === 1 ? 'export' : 'import')
        return <ProjectBlock
            key={index}
            linkTo={linkTo}
            prjType={prjType}
            prjItem = {item}
        />
    })


    // Serializer sample  -- data loaded depending on a logged-in User
    // let [serializerData, setSerializerData] = useState<any>([])
    // console.log('Ser data: ', typeof serializerData)
    //
    // useEffect(()=> {
    //     getNotes()
    // }, [])
    //
    //
    // let getNotes = async () =>{
    //     let response = await fetch(`http://${serverIP}/api/getserializerdata/`, {
    //         method:'GET',
    //         headers:{
    //             'Content-Type':'application/json',
    //             'Authorization':'Bearer ' + String(authTokens.access)
    //         }
    //     })
    //     let data = await response.json()
    //
    //     if (response.status === 200) {
    //         setSerializerData(data)
    //     } else if(response.statusText === 'Unauthorized'){
    //         logoutUser()
    //     }
    // }
    //
    // let mappedLis = serializerData.map((item: any) => (<li key={item.id}>{item.body}</li>))
    // console.log('Mapped LIs: ', mappedLis)

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': ''},
    ]

    const topNavItems = [
        {'name': 'Projects', 'link': ''},
        {'name': 'Templates', 'link': '../templates/1'},
    ]

    const paginate = (pageNumber: number) => setQueryObj(prevState => {
        return {...prevState, currentPage: pageNumber}
    });


    return (

        <>
            <TopNavBar user={user} logoutUser={logoutUser} topNavItems={topNavItems}/>

            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <ProjFilterBlock
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                queryObj={queryObj}
                setQueryObj={setQueryObj}
            />

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small><i>Listing {pageData.totalPosts} items</i></small></div>
                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../projects/`}
                />
            </div>

            <div className="proj-grid-container">
                <div className='prj-grid-header'>
                    <div>Project Name</div>
                    <div>Type</div>
                    <div>Source Taxonomy</div>
                    <div>Target Taxonomy</div>
                    <div>Products</div>
                    <div>Locales</div>
                    <div>Mapped cats</div>
                    <div>Mapped specs</div>
                    <div>Last run</div>
                </div>

                {projElems}
            </div>

            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../projects/`}
            />

            <Footer/>
        </>

    )
}